
import { mapGetters } from 'vuex';

export default {
  i18nComponentKey: 'ReviewsShortsPopup.components.CoachMark',
  name: 'CoachMark',
  computed: {
    ...mapGetters('widget', ['isPcViewport'])
  }
};
